import { render, staticRenderFns } from "./YGRSLGZSPSQ.vue?vue&type=template&id=3f77794f&scoped=true"
import script from "./YGRSLGZSPSQ.vue?vue&type=script&lang=js"
export * from "./YGRSLGZSPSQ.vue?vue&type=script&lang=js"
import style0 from "./YGRSLGZSPSQ.vue?vue&type=style&index=0&id=3f77794f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f77794f",
  null
  
)

export default component.exports